module.exports = __webpack_public_path__ + "img/04.61d33232.png";